/* eslint-disable react/no-children-prop */
import React from 'react';
import useRedirect from 'src/hooks/useRedirect';

const Dream = (): JSX.Element => {
  useRedirect();

  return <></>;
};

export default Dream;
